var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplaylabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18182 4.00195C3.38686 4.00195 2.72727 4.68216 2.72727 5.50195V8.50195C2.32582 8.50195 2 8.83795 2 9.25195V10.752C2 11.166 2.32582 11.502 2.72727 11.502V14.502C2.72727 15.3218 3.38686 16.002 4.18182 16.002H15.8182C16.6131 16.002 17.2727 15.3218 17.2727 14.502V11.502C17.6742 11.502 18 11.166 18 10.752V9.25195C18 8.83795 17.6742 8.50195 17.2727 8.50195V5.50195C17.2727 4.68216 16.6131 4.00195 15.8182 4.00195H4.18182ZM4.18182 5.50195H15.8182V8.50195C15.4167 8.50195 15.0909 8.83795 15.0909 9.25195V10.752C15.0909 11.166 15.4167 11.502 15.8182 11.502V14.502H4.18182V11.502C4.58327 11.502 4.90909 11.166 4.90909 10.752V9.25195C4.90909 8.83795 4.58327 8.50195 4.18182 8.50195V5.50195ZM8.54545 7.00195C8.144 7.00195 7.81818 7.33795 7.81818 7.75195C7.81818 8.16595 8.144 8.50195 8.54545 8.50195H9.27273V12.252C9.27273 12.666 9.59855 13.002 10 13.002C10.4015 13.002 10.7273 12.666 10.7273 12.252V8.50195H11.4545C11.856 8.50195 12.1818 8.16595 12.1818 7.75195C12.1818 7.33795 11.856 7.00195 11.4545 7.00195H10H8.54545Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplaylabel);
export default __webpack_public_path__ + "static/media/Display label.d58926794d3c7d708334d2db613e5b0a.svg";
export { ForwardRef as ReactComponent };